 //PARSING GREENHOUSE JSON
 jQuery(document).ready(function ($) {

   if (gsUrl && $("body").hasClass("careers")) {
     var urllist = $(".greenhousejobspanel");
     var stateFilter = $(".states-filter");
     var deptFilter = $(".depts-filter__container");
     var jobRow = $(".jobopening");
     var states = [];
     var depts = [];

     var greenhouseAPI = gsUrl;
     $.getJSON(greenhouseAPI)
       .done(function (data) {
         $.each(data.jobs, function (i, job) {

           //going to say we have to have a state and a department or we wont show
           if (job.metadata[2].value !== null && job.departments.length !== 0) {

             var thisDepartmentFull = job.departments[0].name;
             var thisStateFull = job.metadata[2].value;

             var thisState = job.metadata[2].value + "|" + job.metadata[2].value.trim().replace(/\s+/g, '-').toLowerCase();
             var thisDept = job.departments[0].name + "|" + job.departments[0].name.trim().replace(/\s+/g, '-').toLowerCase();

             //if state isn't already in bucket, add
             if (!states.includes(thisState)) {
               states.push(thisState);
             }
             //add unique depts to bucket
             if (!depts.includes(thisDept)) {
               depts.push(thisDept);
             }

             var htmlState = thisState.split("|");
             var htmlDept = thisDept.split("|");

             var html = "<div class='jobopening " + htmlState[1] + " " + htmlDept[1] + "'><a href='/careers/?gh_jid=" + job.id +
               "'" + "class='joblink'><span class='jobtitle'>" + (job.title) + " </span><span class='joblocation'>" + (job.location.name) + "</a></div>";

             urllist.append(html);
           }

         });

         var filteredStates = states.filter(function (el) {
           return el != null;
         });

         filteredStates.sort();
         depts.sort();

         //push state and dept values to buttons in DOM
         $.each(filteredStates, function (i, v) {
           var displayState = v.split("|");
           stateFilter.append($('<span class="career-filter state" data-filter="' + displayState[1] + '">' + displayState[0] + '</span>'));
         });

         $.each(depts, function (i, v) {
           var displayDept = v.split("|");
           deptFilter.append($('<span class="career-filter dept" data-filter="' + displayDept[1] + '">' + displayDept[0] + '</span>'));
         });

         $(".career-filter").click(function (el) {
           if ($(this).hasClass('state')) {
             $(".states-filter .career-filter").not(this).removeClass('selected');
           }
           if ($(this).hasClass('dept')) {
             $(".depts-filter .career-filter").not(this).removeClass('selected');
           }
           $(this).toggleClass('selected');

           jobRow.show();

           var activeStateFilters = $(".career-filter.state.selected");
           var activeDeptFilters = $(".career-filter.dept.selected");
           var stateSelector = "";
           var deptSelector = "";

           if (activeStateFilters.length > 0) {
             stateSelector = "." + activeStateFilters.data('filter');
           }
           if (activeDeptFilters.length > 0) {
             deptSelector = "." + activeDeptFilters.data('filter');
           }

           var selector = stateSelector + deptSelector;

           if (selector) {
             $(".jobopening").hide().filter(selector).show();
           } else {
             $(".jobopening").hide().filter(deptSelector).show();
           }

           if (!stateSelector && !deptSelector) {
             $(".jobopening").show();
           }

         });

       });

     var params = new URLSearchParams(window.location.search);

     if (params.has('gh_jid')) {
       $('#grnhse_app').show();
       $('.greenhousejobspanel').hide();
       $('.depts-filter').hide();
       $('.states-filter').hide();
     }
   }

 });